import { Rows3Icon, SquareIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { NAMESPACES } from "@/i18n/constants";
import type { PanelLayout } from "./use-data-viewer-spec";

export function PanelLayoutToggle({
    layout,
    onChange,
}: {
    layout: PanelLayout;
    onChange: (layout: PanelLayout) => void;
}) {
    const { t } = useTranslation(NAMESPACES.FEATURES.DATA_VIEWER, { keyPrefix: "panel-layout-toggle" });

    const stacked = layout === "stacked";
    const label = stacked ? t("switch-to-single") : t("switch-to-stacked");

    return (
        <Button
            aria-label={label}
            aria-pressed={stacked}
            onClick={() => onChange(stacked ? "single" : "stacked")}
            size={"icon"}
            tooltip={label}
            variant={"outline"}
        >
            {stacked ? <SquareIcon /> : <Rows3Icon />}
        </Button>
    );
}
